import { Component, OnInit } from '@angular/core';
import { constants } from 'src/appconstant';
import { RegisterService } from '../register/register.service';
import { FormBuilder, FormGroup,FormArray } from '@angular/forms';
import { ListviewService} from './listview.service'
import { CommonService } from 'src/app/core/services/common/common.service';
import { AppState, selectAnnouncementState ,selectuserState } from 'src/store/reducers';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs/Subscription';
import { Default } from 'src/store/actions/announcementActions';
import { ActivatedRoute } from '@angular/router';

import { NavigationService } from '../../core/services/navigation/navigation.service';
import { toastmessagesService } from "../../core/services/messages/toastmessages.service";
@Component({
  selector: 'app-listview',
  templateUrl: './listview.component.html',
  styleUrls: ['./listview.component.scss']
})
export class ListviewComponent implements OnInit {
  announcements;
  categories;
  cities;
  search = [];
  totalAnnouncementCount;
  getState: Observable<any>;
  searchAnnouncementSubscription:Subscription;
  loadMore:boolean = false;
  start;
  end;
  totalAnnouncementGet;
  category_id;
  query_type;
  query_name;
  searchParam = {};
  constructor(private route: ActivatedRoute, 
    private register: RegisterService,
    private fb: FormBuilder,
    private commonService: CommonService,
    private store: Store<AppState>,
    private spinner: NgxSpinnerService,
    private message: toastmessagesService,
    private navigation: NavigationService,
    private listViewService: ListviewService
    ) { 
    this.start = 10;
    this.end = 0;
    this.getQueryParams();
    this.defaultDropdowns();
   
    this.getState = this.store.select(selectAnnouncementState);

  }

  ngOnInit() {
    this.searchAnnouncementSubscription = this.getState.subscribe((state) => {
      if (state.action === 'search-announcement') {
        this.view(state);
      }
    });
  }
  ngOnDestroy(): void { this.searchAnnouncementSubscription.unsubscribe(); }
  getQueryParams() {
    this.route.queryParams.subscribe(params => {
      const param = params['type'];
      const name = params['title'];
    console.log(param,"para",name);
      // this.query = ((param === 'seller') && '0') ||  ((param === 'buyer') && '1') || '';

     /*  if(param == undefined || name == undefined){
        this.getByrAnncmts(this.end,this.start);
      }
      else{ */
        this.announcements = (param === 'seller' && this.getByrAnncmts(this.end,this.start,'1')) 
        || (param === 'buyer' && this.getByrAnncmts(this.end,this.start,'0')) ||  
        (param === 'both' && this.getByrAnncmts(this.end,this.start)) ||
        (name != null && this.getByrAnncmts(this.end,this.start,'',name))   ; 
    // }
     
    });
    
  }

 /*  getSelrAnncmts()
  {
    console.log("in seller",this.announcements);
    let queryParams;
    let type = 1;
    queryParams = `${type}=1&min=0&max=10`
    this.listViewService.dispatchsearchAnnouncementAction(queryParams);
  } */
  getByrAnncmts(min,max,type?,name?)
  {
    this.spinner.show();
    console.log(this.end,"obj",this.start)
    console.log("in buyer & seller",this.announcements);
    let queryParams = '';
    if(type){
   
      this.query_type = type;
      console.log("inside type query",typeof this.query_type);
      this.searchParam['type'] = type;
    }
    if(name){
      this.query_name =name;
      this.searchParam['title'] = name;
    
    }
    
    this.searchParam['max'] = max;
    this.searchParam['min'] = min;
    for (var key in this.searchParam) {

      // if (key != 'category' && key != 'sub_category') {
        console.log(this.searchParam[key],"this.searchParam[key]")
      if(this.searchParam[key] != undefined){
        if (queryParams == '') {
          queryParams = `${key}=${this.searchParam[key]}`
        }
        else {
          queryParams += `&${key}=${this.searchParam[key]}`
        }
      }
     
      // }
    }
    console.log("abcs",queryParams)
    this.listViewService.dispatchsearchAnnouncementAction(queryParams);
  }

/*   getAll(min,max)
  {
    this.spinner.show();
    console.log("getAll");
    let queryParams = `min=${this.end}&max=${this.start}`;
    this.listViewService.dispatchsearchAnnouncementAction(queryParams);
  } */
  retrieveImage(image) {  
    return (image === '' || image === undefined) && "../../../assets/images/noImageFound.jpg" || constants.AWS_URL + image;
  }

  getComma(length, index) {
    return (length === index) && '' || ',';
  }
  defaultDropdowns(){
    this.getCategories();
    this.cities = this.listViewService.getCities();
  }
  getCategories() {
    let cat = this.listViewService.getStateOfCategories();
      cat.subscribe((state) => {
       if (state.categories) {
         this.categories = state.categories;
       }
     }); 
  }
  view(state) {
    if(state.success){
      if (state.search.rows.length > 0) {
        this.search.push(...state.search.rows);
        this.totalAnnouncementCount = state.search.count;
        if(state.search.count > 8 && state.search.rows.length > 9){
          this.loadMore = true;
        }else{
          this.loadMore = false;
        }
        this.totalAnnouncementGet = state.search.rows.length
        this.store.dispatch(new Default({}));
        this.spinner.hide();
      }
      else {
        this.spinner.hide();
      }
    }
    else if (!state.success && state.success !== null && state.success !== undefined) {
      this.spinner.hide();
      this.sucesserrorMsg('errorToastr', state.errorMessage);
      this.store.dispatch(new Default({}));
    }
  
  }
  sucesserrorMsg(status, message) {
    this.message.messageHandler(status, message);
  }
  selectCategory(id){
    this.searchParam['category_ids'] = id;
    this.search = [];
    this.start = 10;
    this.end = 0;
    this.getByrAnncmts(this.end,this.start);
  }
  selectCity(city){
    this.searchParam['city'] = city;
    this.search = [];
    this.start = 10;
    this.end = 0;
    this.getByrAnncmts(this.end,this.start);
  }
  selectType(type){
    this.searchParam['type'] = type;
    this.query_type = type;
    this.search = [];
    this.start = 10;
    this.end = 0;
    this.getByrAnncmts(this.end,this.start);
  }
  clickLoadMore(){
    this.end = this.start;
    this.start = this.start + 10;
    if(this.query_type){
      this.getByrAnncmts(this.end,this.start,this.query_type)
    }
    else if(this.query_name){
      this.getByrAnncmts(this.end,this.start,null,this.query_name)
    }
    else{
      this.getByrAnncmts(this.end,this.start)
    }
    
    console.log(this.searchParam,"load more");
  
  }
  routeTo(path,id){
    if(localStorage.getItem("token")){
    this.navigation.navigateTo([`${path}/${id}`]);
    }
    else{
      this.navigation.navigateTo('login');
    }
  }
  getColor(type){
    if(type == '0'){
  const style = {
    base : {
    background: 'white',
    color: '#9a3e0b',
    }
  }
    }
  }
}
